import { CButton, CFormInput, CFormLabel, CFormTextarea } from "@coreui/react";
import { useEffect, useState } from "react";
import AsyncSelect from "react-select/async";
import AxiosInstance from "src/components/Axios";
import { toast } from 'react-toastify'


export default function PlanTypes() {
   // хто увійшов
   const role = localStorage.getItem('user_role')
   // console.log(role)


   //для селекта
   const [typeTitle, setTypeTitle] = useState('')

   //для нового етапу в інпуті
   const [typeInputText, setTypeInputText] = useState('')


   //для нового етапу в інпуті
   const [typeDescriptionText, setTypeDescriptionText] = useState('')
   //для оновлення селекта
   const [reloadKey, setReloadKey] = useState(0)


   //стилі для селекту
   const customStyles = {
      menuList: (provided) => ({
         ...provided,
         maxHeight: '200px',
         overflowY: 'auto',
      }),
   };


   const loadOptions = async (inputValue = '') => {
      if (role === 'ROLE_ADMIN') {
         return await AxiosInstance.get(`/work_types_lists?name=${inputValue}`
            // , header
         ).then((response) => {
            console.log('response.data', response.data)
            return response.data['hydra:member'].map((result) => ({
               label: result.name,
               value: result.id,
            }));
         });
      } else {
         // if (userData.id) {
         //    return await AxiosInstance.get(`/accounts?user.id=${userData.id}&name=${inputValue}`, header).then((response) => {
         //       return response.data.map((result) => ({
         //          label: result.name,
         //          value: result.id,
         //       }));
         //    });
         // }
         return []
      }
   }

   // функція для додавання типу
   function addItem() {
      if (typeInputText === '' || typeDescriptionText === '') return

      const send_data = {
         name: typeInputText,
         description: typeDescriptionText
      }

      AxiosInstance.post(`/work_types_lists`, send_data
         // , header
      ).then((response) => {
         console.log('response.data', response.data)
         // return response.data.map((result) => ({
         //    label: result.name,
         //    value: result.id,
         // }));
         toast.success('Новий тип роботи додано')
         setTypeInputText('')
         setTypeDescriptionText('')
         setReloadKey((prev) => prev + 1)

      }).catch(e => toast.error('Новий тип роботи не додано'));

   }



   if (role !== 'ROLE_ADMIN') { return }

   return (
      <>
         {/* Частина з реакт селектом этапів */}
         <div>
            <h2>Список типів</h2>
            <AsyncSelect
               key={reloadKey}
               cacheOptions
               loadOptions={loadOptions}
               defaultOptions
               // value={partnerFilterSearch}
               // onChange={handleChangePartner}
               className="flex-grow-1"
               placeholder="Типи робіт"
               styles={customStyles}

            />
         </div>
         {/* Частина для додавання нового етапу до довідника з інпутом для назви */}
         <div>
            <CFormLabel className="mt-3" htmlFor="exampleFormControlInput2">Введіть назву типу</CFormLabel>
            <CFormInput
               type="text"
               id="exampleFormControlInput1"
               // defaultValue="Введіть назву нового етапу"
               value={typeInputText}
               onChange={(e) => setTypeInputText(e.target.value)}
               placeholder="Введіть назву типу"
               autoComplete="off"
            />

         </div>

         <div>
            <CFormLabel className="mt-3" htmlFor="exampleFormControlInput2">Введіть опис етапу</CFormLabel>
            <CFormTextarea
               type="text"
               id="exampleFormControlInput2"
               // defaultValue="Введіть опис нового етапу"
               value={typeDescriptionText}
               onChange={(e) => setTypeDescriptionText(e.target.value)}
               placeholder="Введіть опис типу"
               autoComplete="off"
            />

         </div>
         <CButton className="mt-3" onClick={addItem} >Додати</CButton>

      </>
   )
}